import { useState, useEffect } from "react";
import { process } from "@progress/kendo-data-query";

const DEFAULT_DATA_STATE = {
  sort: [{ field: "code", dir: "asc" }],
  skip: 0,
  take: 20,
};

const useRollCallGrid = (data) => {
  const [dataState, setDataState] = useState(DEFAULT_DATA_STATE);
  const [dataResult, setDataResult] = useState(process(data, DEFAULT_DATA_STATE));

  useEffect(() => {
    setDataState(DEFAULT_DATA_STATE);
    setDataResult(process(data, DEFAULT_DATA_STATE));
  }, [data]);

  const onDataStateChange = (e) => {
    setDataState(e.dataState);
    setDataResult(process(data, e.dataState));
  };

  return { dataState, dataResult, onDataStateChange };
};

export default useRollCallGrid;